var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeesactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 20,
    height: 5,
    rx: 2,
    fill: "#FED200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9592 4C13.5272 4 13.9811 4.47246 13.9584 5.03997L13.6384 13.04C13.6169 13.5763 13.1759 14 12.6392 14L11.3608 14C10.8241 14 10.3831 13.5763 10.3616 13.04L10.0416 5.03997C10.0189 4.47246 10.4728 4 11.0408 4L12.9592 4Z",
    fill: "#FED200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1104 14C20.6285 14 21.0542 13.5112 20.9944 12.9143C20.8256 11.2318 20.2676 9.65154 19.3883 8.40301C18.5408 7.19955 17.4457 6.37655 16.2527 6.02759C15.7443 5.87887 15.2895 6.35161 15.2626 6.95896L15.0013 12.8561C14.9737 13.4781 15.4011 14 15.9382 14H20.1104Z",
    fill: "#FED200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88959 14C3.37147 14 2.94576 13.5112 3.00563 12.9143C3.17439 11.2318 3.73243 9.65154 4.61169 8.40301C5.45922 7.19955 6.55431 6.37655 7.7473 6.02759C8.25573 5.87887 8.71046 6.35161 8.73738 6.95896L8.99874 12.8561C9.02631 13.4781 8.59887 14 8.06182 14H3.88959Z",
    fill: "#FED200"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesactive);
export default __webpack_public_path__ + "static/media/employeesactive.5a698744aee2e331b8b8f47c6dd50cc4.svg";
export { ForwardRef as ReactComponent };